import React from "react";
import { connect } from 'react-redux'
import CompanyPagesTab from '../../components/company-pages-tab'
import { fetchEmployerAccess, createEmployerAccess, activateEmployerAccess } from '../../api/employer-access/actions'
import { fetchCompanyDetails } from '../../api/company-details/actions'
import { formatKennitala } from '../../utils'
import EmployerAccessRequest from "../../components/employer-access-request";

const kennitala = require('kennitala')

import Select from 'react-select';


class CompanyPages extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentCompany: {},
            companyArray: {},
        }

        this.selectCompany = this.selectCompany.bind(this)
        this.onChangeInput = this.onChangeInput.bind(this)
        this.activateAccess = this.activateAccess.bind(this)
        this.getNewCode = this.getNewCode.bind(this)
        this.inputValue = this.inputValue.bind(this)
    }

    componentDidMount() {
        if(!window.isIE()) {
            this.props.dispatch(fetchEmployerAccess())
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(JSON.stringify(prevProps.employerAccess) !== JSON.stringify(this.props.employerAccess)){
            this.setState({currentCompany: this.props.employerAccess.currentCompany})
            this.setState({companyArray: this.props.employerAccess.data.access.filter(f => f.active)})
        }
        if(JSON.stringify(prevProps.employerAccess.currentCompany) !== JSON.stringify(this.props.employerAccess.currentCompany)){
            this.props.dispatch(fetchCompanyDetails(this.props.employerAccess.currentCompany.company_id))
        }
    }
        
    selectCompany(event){
        this.setState({currentCompany: this.state.companyArray[""+event.value].company})
        this.props.dispatch(fetchCompanyDetails(this.state.companyArray[""+event.value].company.company_id))
    }

    onChangeInput(companyId, evt) {
        let token = evt.target.value.trim();
        this.setState({tokens: {[companyId]: token}})
    }

    activateAccess(companyId) {
        let token = this.state.tokens[companyId]
        this.props.dispatch(activateEmployerAccess({company_id: companyId, token: token}))
    }

    getNewCode(companyId) {
        this.setState({tokens: {[companyId]: ""}})
        this.props.dispatch(createEmployerAccess({company_id: companyId, override: true}))
    }

    inputValue(companyId) {
        try {
            return this.state.tokens[companyId]
        } catch(e) {
            return ""
        }
    }

    render() {

        if (window.isIE()) {
            return (<>
                <div className="page-error">
                    <div className="container justify-content-center text-center">
                        <div className="heading col-12 col-sm-8 mx-auto">
                            <h1>Úpps!</h1>
                            <h2>Við styðjum því miður ekki Internet Explorer. Vinsamlegast notaðu Edge, Chrome, eða Firefox.</h2>
                        </div>
                        <div className="img-container">
                            <img className="img-fluid" src={window.images.iceCream}/>
                        </div>
                        <a className="link mx-auto" href="/">Til baka á forsíðu</a>
                    </div>
                </div> 
            </>)
        }
        

        let declarations = this.props.employerDeclaration;
        
        let options = []

        if (this.props.employerAccess.showCompanySelection) {
            options = this.state.companyArray.map((j, i) => {
                return {value: i, label: j.company.name}
            })
        }
        

        if(this.props.employerAccess.data.access.length >= 1){
                    return(
                        <>
                            { this.props.employerAccess.data.access.filter(f => !f.active).length > 0 &&
                                <div className="alert alert-info xs-mb-40">
                                    Þú ert með opnar aðgangsbeiðnir. Aðgangsbeiðni hefur verið send í netbanka viðkomandi aðila undir rafræn skjöl. Til að virkja beiðnina þarf
                                    að afrita aðgangskóðann sem er að finna í rafræna skjalinu í netbanka í reitinn hér að neðan. <br />
                                    <strong>Athugið að það getur tekið allt að 20 mínútur fyrir skjalið að berast í netbankann.</strong>
                                    <ul>
                                    { this.props.employerAccess.data.access.filter(f => !f.active).map(f => 
                                        <li>
                                            { f.company.name } ({ formatKennitala(f.company.company_id)}) <input placeholder={`Kóði byrjar á ${f.token_display}`} onChange={(e) => this.onChangeInput(f.company.company_id, e)} value={this.inputValue(f.company.company_id)} /><button onClick={() => this.activateAccess(f.company.company_id)} className="btn btn-sm btn-primary">Virkja</button>
                                            {this.props.employerAccess.create === null &&
                                                <button className="btn btn-sm btn-warning xs-ml-15" onClick={() => this.getNewCode(f.company.company_id)}>Senda nýjan aðgangskóða í netbanka</button>
                                            }
                                            {this.props.employerAccess.create && this.props.employerAccess.create[f.company.company_id] === 'init' &&
                                                <button className="btn btn-sm btn-warning xs-ml-15" disabled>Augnablik...</button>
                                            }
                                            {this.props.employerAccess.create && this.props.employerAccess.create[f.company.company_id] === 'done' &&
                                                <span className="xs-ml-15">Nýr kóði sendur</span>
                                            }
                                        </li>
                                    )}
                                    </ul>
                                </div>
                            }
                            { this.props.employerAccess.error !== "" &&
                                <div className="alert alert-danger">
                                    { this.props.employerAccess.error }
                                </div>
                            }
                            { this.props.employerAccess.data.access.filter(f => f.active).length >= 1 &&
                                <>
                                    <div className="title-wrapper row">
                                        <div className="title col-8">Launagreiðendavefur</div>
                                        <div className="title col-4">
                                            { this.props.employerAccess.showCompanySelection &&
                                                <Select
                                                    placeholder="Veldu fyrirtæki"
                                                    options={options}
                                                    onChange={this.selectCompany}
                                                    defaultValue={0}
                                                    className='react-select-container'
                                                    classNamePrefix="react-select"
                                                    blurInputOnSelect={true}
                                                    
                                                />
                                            }
                                        </div>

                                    </div>
                                
                                    { JSON.stringify(this.state.currentCompany) !== "{}" &&
                                        <div className="employer-content tab-content w-100 step" id="pills-tabContent">
                                            <CompanyPagesTab company={this.state.currentCompany} companyDetails={this.props.companyDetails} dispatch={this.props.dispatch} declarations={declarations}/>
                                        </div>
                                    } 
                                </>
                            }
                        </>
                    )
        } else {
            return (
                <div className="container">
                    <div className="title">Launagreiðendavefur</div>
                    <div className="row justify-content-center xs-pb-40">
                        <div className="col-12 text-center">
                            <img className="img-fluid" src={window.images.myPagesEmpty} />
                        </div>
                    </div>
                    <div className="row justify-content-center xs-pb-40">
                        <div className="col-12 col-sm-4 text-center">
                            <p>Þú ert ekki með aðgang sem launagreiðendaandi.</p>
                            <p>Þú getur sótt um launagreiðendaaðgang, sem einstaklingur, eða fyrir hönd fyrirtækis, ef þú hefur
                                aðgang að netbanka viðkomandi fyrirtækis.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-sm-6 col-12 text-center">
                            <EmployerAccessRequest />
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {

    var f = {
        employerDeclaration: {},
        employerAccess: {},
        currentCompany: {},
        companyDetails: {}
    }
    f.employerDeclaration = (state.employerDeclaration === undefined) ? {} : state.employerDeclaration
    f.employerAccess = (state.employerAccess === undefined) ? {} : state.employerAccess
    f.currentCompany = (state.currentCompany === undefined) ? {} : state.currentCompany
    f.companyDetails = (state.companyDetails === undefined) ? {} : state.companyDetails
    return f;
}

export default connect(mapStateToProps)(CompanyPages);
